/**
 * @flow
 * @relayHash 968a1d171fabfa8b04f4a00084837919
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type DesignProfileStatus = "ACTIVE" | "DELETED" | "NEW" | "PENDING" | "%future added value";
export type TradeFirmSalesTier = "P_AND_M" | "TIER_1" | "TIER_2" | "TIER_3" | "TIER_4" | "UNKNOWN" | "%future added value";
export type initializeTrackingQueryVariables = {|
  hasUserId: boolean,
  userId: string,
  userIds?: ?$ReadOnlyArray<string>,
|};
export type initializeTrackingQueryResponse = {|
  +viewer: ?{|
    +submittedTransactions?: ?{|
      +totalResults: ?number
    |},
    +confirmedTransactionsMostRecent?: ?{|
      +totalResults: ?number
    |},
    +user?: ?{|
      +createdDate: ?string,
      +firstSessionDate: ?string,
      +isTrade: ?boolean,
      +hasVipPermission: ?boolean,
      +authMetadata: ?{|
        +emailOnly: ?boolean,
        +hasPassword: ?boolean,
      |},
      +profile: ?{|
        +email: ?string,
        +zipCode: ?string,
        +currency: ?Currency,
      |},
      +serviceId: ?string,
      +totalMessagesToDealers: ?number,
      +tradeFirm: ?{|
        +serviceId: ?string,
        +tier: ?TradeFirmSalesTier,
        +profileStatus: ?DesignProfileStatus,
        +rewards: ?{|
          +currentProgram: ?{|
            +programInfo: ?{|
              +code: ?string
            |}
          |}
        |},
      |},
      +verifiedTradeStatus: ?string,
    |},
  |}
|};
export type initializeTrackingQuery = {|
  variables: initializeTrackingQueryVariables,
  response: initializeTrackingQueryResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "hasUserId",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userIds",
    "type": "[String!]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userIds",
  "type": "[String]"
},
v2 = {
  "kind": "Literal",
  "name": "first",
  "value": 0,
  "type": "Int"
},
v3 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "totalResults",
    "args": null,
    "storageKey": null
  }
],
v4 = {
  "kind": "LinkedField",
  "alias": "submittedTransactions",
  "name": "transactions",
  "storageKey": null,
  "args": [
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "kind": "Literal",
      "name": "viewName",
      "value": "buyerTracking.submitted",
      "type": "String"
    }
  ],
  "concreteType": "TransactionConnection",
  "plural": false,
  "selections": (v3/*: any*/)
},
v5 = {
  "kind": "LinkedField",
  "alias": "confirmedTransactionsMostRecent",
  "name": "transactions",
  "storageKey": null,
  "args": [
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "kind": "Literal",
      "name": "viewName",
      "value": "buyerTracking.confirmed",
      "type": "String"
    }
  ],
  "concreteType": "TransactionConnection",
  "plural": false,
  "selections": (v3/*: any*/)
},
v6 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }
],
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdDate",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstSessionDate",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": "isTrade",
  "name": "hasPermission",
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "B_VERIFIED_TRADE",
      "type": "String!"
    }
  ],
  "storageKey": "hasPermission(name:\"B_VERIFIED_TRADE\")"
},
v10 = {
  "kind": "ScalarField",
  "alias": "hasVipPermission",
  "name": "hasPermission",
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "B_VIP_CHECKOUT",
      "type": "String!"
    }
  ],
  "storageKey": "hasPermission(name:\"B_VIP_CHECKOUT\")"
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "emailOnly",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasPassword",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "profile",
  "storageKey": null,
  "args": null,
  "concreteType": "Profile",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "email",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "zipCode",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "currency",
      "args": null,
      "storageKey": null
    }
  ]
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalMessagesToDealers",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "tier",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "profileStatus",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "verifiedTradeStatus",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "initializeTrackingQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v6/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "authMetadata",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserExistsMetadataType",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v12/*: any*/)
                    ]
                  },
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "tradeFirm",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TradeFirmType",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "rewards",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "currentProgram",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ParentProgram",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "programInfo",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "LoyaltyProgram",
                                "plural": false,
                                "selections": [
                                  (v18/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v19/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "initializeTrackingQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v20/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v6/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v7/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "authMetadata",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserExistsMetadataType",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v20/*: any*/)
                    ]
                  },
                  (v8/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "tradeFirm",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TradeFirmType",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "rewards",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "currentProgram",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ParentProgram",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "programInfo",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "LoyaltyProgram",
                                "plural": false,
                                "selections": [
                                  (v18/*: any*/),
                                  (v20/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v20/*: any*/)
                    ]
                  },
                  (v19/*: any*/),
                  (v20/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "initializeTrackingQuery",
    "id": "dibs-buyer-layout/213.2.1-2019-04-23T05:41:12.419Z/initializeTrackingQuery",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '26f22af53212468a4de3369e05f696a0';
module.exports = node;
